module.exports = __webpack_public_path__ + "static/media/thumb_REDL1837_1024a.209d07a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/kama_yunek/thumb_REDL1837_1024a.jpg
// module id = 157
// module chunks = 0